<template>
  <q-dialog @show="getFile" persistent v-model="dialogMediaKit">
    <q-card>
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title>Media Kit</q-toolbar-title>
        <q-btn flat round dense icon="mdi-close" @click="onClose" />
      </q-toolbar>
      <img :src="fileUrl" />
      <div v-if="pdfUrl" style="margin-top: 20px">
        <iframe :src="pdfUrl" width="545px" height="600px" style="border: none"></iframe>
      </div>

      <div v-if="pptxUrl" class="text-h6 text-center">
        <p>Arquivo em formato .PPTX. Não é possível realizar a exibição. Prossiga para realizar o download.</p>
      </div>

      <q-card-actions class="q-pa-md justify-between">
        <input
          ref="popUpFileInput"
          type="file"
          style="display: none"
          @change="onFileChange"
          accept=".pdf, .ppt, .pptx, .png, .jpg, .jpeg"
        />

        <q-btn
          unelevated
          color="primary"
          outline
          class="q-px-md"
          :label="$t('substitute_media_kit')"
          @click="$refs.popUpFileInput.click()"
          v-if="user.profile == 'afiliado'"
        />
        <q-btn unelevated color="primary" :label="$t('download_media_kit')" @click="downloadFile" class="q-px-md" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import FileService from '@/services/FileService';
import AffiliateMixin from '@/mixins/AffiliateMixin';
import AffiliateService from '@/services/AffiliateService';
export default {
  name: 'AffiliateMediaKitPopUp',
  mixins: [FileService, AffiliateMixin, AffiliateService],
  data() {
    return {
      fileUrl: '',
      pdfUrl: '',
      pptxUrl: ''
    };
  },
  props: {
    affiliateData: { type: Object },
    dialog: { type: Boolean, default: true }
  },
  methods: {
    onClose() {
      this.ActionSetDialogMediaKit(false);
      this.fileUrl = '';
      this.pdfUrl = '';
      this.pptxUrl = '';
    },

    downloadFile() {
      let url = null;
      let filename = `media_kit_affiliate_${this.affiliateData.id}`;

      if (this.fileUrl) {
        url = this.fileUrl;
        const ext = this.affiliateData.media_kit_type.split('/')[1];

        filename += `.${ext}`;
      } else if (this.pdfUrl) {
        url = this.pdfUrl;
        filename += '.pdf';
      } else if (this.pptxUrl) {
        url = this.pptxUrl;
        filename += '.pptx';
      } else {
        this.warningNotify('Arquivo não disponível para download.');
        return;
      }

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async getFile() {
      try {
        this.onLoading(true);
        const { data, headers } = await this.getFileContent(
          1,
          'affiliate_media_kit',
          `?path=${this.affiliateData.media_kit}&type=${this.affiliateData.media_kit_type}`
        );
        const content = headers['content-type'];

        if (content.includes('image')) {
          const base64 = this.arrayBufferToBase64(data);
          const imgSrc = `data:${content};base64,${base64}`;
          this.fileUrl = imgSrc;
        } else if (content.includes('pdf')) {
          const blob = new Blob([data], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);

          // Guarda a URL no data para o iframe
          this.pdfUrl = url;
        } else if (content.includes('officedocument')) {
          const blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          });
          const url = URL.createObjectURL(blob);
          this.pptxUrl = url;
        }
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    arrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    async onFileChange(event) {
      const file = event.target.files[0];
      const renameTo = `mediakit_affiliate_${this.user.user_id}_${this.$moment().format(
        'YYYY-MM-DD'
      )}_${this.uuidV4()}`;
      if (file) {
        let form = new FormData();
        form.append('file', file);
        form.append('file_rename', renameTo);
        form.append('bucket', 's3AffiliateMediaKit');

        try {
          this.onLoading(true);
          const { status } = await this.uploadFile(form);
          if (status == 200) {
            await this.editAffiliateData(this.id, { media_kit: renameTo, media_kit_type: file.type });

            this.affiliateData.media_kit = renameTo;
            this.affiliateData.media_kit_type = file.type;

            this.pdfUrl = '';
            this.fileUrl = '';
            this.pptxUrl = '';

            await this.getFile();
            this.$emit('update_media_kit', { media_kit: renameTo, media_kit_type: file.type });
            this.successNotify('media_kit_changed_successfully');
          }
        } catch (error) {
          this.errorNotify(error);
        } finally {
          this.onLoading(false);
        }
      }
    }
  }
};
</script>

<style></style>
